(() => {
  async function recoverStyles() {
    const link = document.querySelector('link[rel="stylesheet"][href*="/compiled_assets/styles.css"]');
    if (!link || link.disabled || link.dataset.rtmCssRecovery) return;

    let sheet;
    let url;
    try {
      url = new URL(link.href, document.baseURI);
      if (url.origin !== location.origin || !/^\/cdn\/shop\/t\/\d+\/compiled_assets\/styles\.css$/.test(url.pathname)) return;
      sheet = link.sheet;
      if (!sheet || sheet.disabled) return;
      if (sheet.cssRules.length > 0) {
        link.dataset.rtmCssRecovery = 'ready';
        return;
      }
    } catch {
      return;
    }

    link.dataset.rtmCssRecovery = 'pending';
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    let added = 0;
    try {
      const response = await fetch(url.href, {
        cache: 'reload',
        credentials: 'same-origin',
        signal: controller.signal,
      });
      if (!response.ok || !response.headers.get('content-type')?.toLowerCase().startsWith('text/css')) {
        throw new Error('Unexpected stylesheet response');
      }
      const css = await response.text();
      if (/@import\b/i.test(css)) throw new Error('Imported stylesheets require normal loading');
      const parsed = new CSSStyleSheet({ baseURL: url.href });
      parsed.replaceSync(css);
      if (!parsed.cssRules.length) throw new Error('The stylesheet has no rules');
      if (!link.isConnected || link.sheet !== sheet || link.href !== url.href || link.disabled || sheet.disabled) {
        link.dataset.rtmCssRecovery = 'skipped';
        return;
      }
      if (sheet.cssRules.length > 0) {
        link.dataset.rtmCssRecovery = 'ready';
        return;
      }
      for (const rule of parsed.cssRules) {
        sheet.insertRule(rule.cssText, sheet.cssRules.length);
        added += 1;
      }
      link.dataset.rtmCssRecovery = 'recovered';
      window.dispatchEvent(new Event('resize'));
    } catch (error) {
      while (added > 0) {
        sheet.deleteRule(--added);
      }
      link.dataset.rtmCssRecovery = 'failed';
      console.warn('Retromotive stylesheet recovery could not complete.', error);
    } finally {
      clearTimeout(timeout);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', recoverStyles, { once: true });
  } else {
    void recoverStyles();
  }
})();
